import { useCallback } from 'react';

import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { useLazyGetSelectionProductQuery } from 'shared/api/selection';
import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TRankingProductRequest } from 'shared/types/TRankingService';

import { mapMplProductTypeToLeadGenProductType } from '../mapMplProductTypeToLeadGenProductType';

import { mergeMplOfferToRankingOffer } from './mergeMplOfferToRankingOffer';

export const useLoadRankingOfferByMplOffer = () => {
  const [loadProduct, { isLoading }] = useLazyGetSelectionProductQuery();

  const loadOffer = useCallback(
    async (offer: MPLPreApprovalOffer, formData: Omit<TRankingProductRequest, 'productType' | 'id'>) => {
      try {
        const response = await loadProduct(
          {
            ...formData,
            productType: mapMplProductTypeToLeadGenProductType(offer.productType),
            id: offer.productId,
          },
          true,
        ).unwrap();
        if (response && response.offer) {
          return mergeMplOfferToRankingOffer(offer, response.offer);
        }
        sendSentryClientErrorOnce('useLoadRankingOfferByMplOffer error', 'Empty response.offer', {
          productId: offer.productId,
          productType: offer.productType,
        });
        return null;
      } catch (error) {
        sendSentryClientErrorOnce('useLoadRankingOfferByMplOffer error', error, {
          productId: offer.productId,
          productType: offer.productType,
        });
        return null;
      }
    },
    [loadProduct],
  );

  return { loadOffer, isLoading };
};
